import { Grid } from "@mui/material";
import CustomisedCardLine from "../../../../../components/card/cardLine";
import { IGuaranteeInfo } from "./IGuaranteeTab";
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import GppGoodIcon from '@mui/icons-material/GppGood';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MailBox from "../../../../../components/icons/MailBox";

export default function GuaranteeTab({ guarantors, userInfo, handleAttachedImage, showAttachedFileButton, tabIndex }: IGuaranteeInfo) {



    var x: { [key: number]: string } = {
        1: "اول",
        2: "دوم",
        3: "سوم",
        4: "چهارم",
        5: "پنجم",
        6: "ششم",
        7: "هفتم",
        8: "هشتم",
        9: "نهم",
        10: "دهم",
        11: "یازدهم",
        12: "دوازدهم",
        13: "سیزدهم",
        14: "چهاردهم",
        15: "پانزدهم",
        16: "شانزدهم",
        17: "هفدهم",
        18: "هجدهم",
        19: "نوزدهم",
        20: "بیستم",
        21: "بیست و یکم",
        22: "بیست و دوم",
        23: "بیست و سوم",
        24: "بیست و چهارم",
        25: "بیست و پنجم",
        26: "بیست و ششم",
        27: "بیست و هفتم",
        28: "بیست و هشتم",
        29: "بیست و نهم",
        30: "سی ام",
        31: "سی و یکم",
        32: "سی و دوم",
        33: "سی و سوم",
        34: "سی و چهارم",
        35: "سی و پنجم",
        36: "سی و ششم",
        37: "سی و هفتم",
        38: "سی و هشتم",
        39: "سی و نهم",
        40: "چهلم",
        41: "چهل و یکم",
        42: "چهل و دوم",
        43: "چهل و سوم",
        44: "چهل و چهارم",
        45: "چهل و پنجم",
        46: "چهل و ششم",
        47: "چهل و هفتم",
        48: "چهل و هشتم",
    };

    const handleAttachedImages = () => {
        //dispatch(getpervStateTab({ prevState: 'loanDetail '+randomKeyForDispatch }))
        // dispatch(changeRouteType({ routeType: 'loanDetail' }));

        //dispatch(getpervInnerState({ prevInnerState: `handleLoanDetail`}));
        handleAttachedImage(tabIndex);
    }
    return (
        <>
            <div style={{ height: "100%" }} className='container-height-without-drawer'>
                <Grid className='heightContainer' style={{ overflowY: "auto", maxHeight: "100%" }}>
                    {userInfo != null && userInfo.length > 0 ?
                        <div
                            style={{
                                margin: 'auto',

                            }}
                        >
                            <div style={{ paddingBottom: '10px' }}>
                                <span
                                    className="font-normal text-sm primaryColorLight-900 anjomanRegular"
                                    style={{ fontSize: '14px' }}
                                >
                                    اطلاعات ضمانتی شما
                                </span>
                            </div>
                            <CustomisedCardLine
                                itemList={userInfo}></CustomisedCardLine>
                        </div> : <></>}

                    {guarantors != null && guarantors.length > 0 ?
                        guarantors.map((item: any, index: any) => {

                            const userGaurantorTemp = [
                                {
                                    title: <><PersonIcon sx={{ marginLeft: "5px" }} />نام و نام خانوادگی</>
                                    ,
                                    value: item.fullName,
                                },
                                {
                                    title: <><BadgeIcon sx={{ marginLeft: "5px" }} />کد ملی</>
                                    ,
                                    value: item.nationalCode
                                },
                                {
                                    title: <><CalendarMonthIcon sx={{ marginLeft: "5px" }} />تاریخ تولد</>,
                                    value: item.birthDate
                                },
                                {
                                    title: <><PhoneIphoneIcon sx={{ marginLeft: "5px" }} />شماره موبایل</>,
                                    value: item.mobileNumber
                                },
                                {

                                    title: <><MailBox sx={{ marginLeft: "5px", fontSize: "20px", marginBottom: "5px" }} />کد پستی</>
                                    ,
                                    value: item.postalCode
                                },
                                {
                                    title: <><GppGoodIcon sx={{ marginLeft: "5px" }} />نوع ضمانت</>,
                                    value: item.guaranteeTypeTitle
                                },
                                {
                                    title: <><AttachMoneyIcon sx={{ marginLeft: "5px" }} /> میانگین درآمد (ريال)</>,
                                    value: item.incomeAverage
                                },
                            ];

                            return (
                                <div
                                    style={{
                                        margin: 'auto',
                                        marginTop: "25px"
                                    }}
                                >
                                    <div style={{ paddingBottom: '10px' }}>
                                        <span
                                            className="font-normal text-sm primaryColorLight-900 anjomanRegular"
                                            style={{ fontSize: '14px' }}
                                        >
                                            اطلاعات ضامن {x[index + 1]}:
                                        </span>
                                    </div>
                                    <CustomisedCardLine
                                        itemList={userGaurantorTemp}></CustomisedCardLine>
                                </div>)
                        })

                        : <></>}
                    <div
                        style={{
                            margin: 'auto',
                            marginTop: "40px",
                            paddingBottom: "40px"
                        }}
                    >
                        {showAttachedFileButton ?
                            <div style={{ paddingBottom: '20px' }}
                                onClick={handleAttachedImages}>
                                <span
                                    className=" text-sm primaryColorLight anjomanSemiBold"
                                    style={{ fontSize: '15px' }}
                                >
                                    مشاهده مستندات ضمانتی پرونده
                                </span>
                            </div> :
                            <></>}

                    </div>
                </Grid >
            </div >
        </>
    )

}